import React from "react";
import { Card, KeyValueList, LongTextLabel, ValueOrPlaceholder, } from "@sscs/ui";
import styles from "./cryptoAsset.module.scss";
const Summary = ({ protocol }) => {
    const ciphers = protocol.ciphers
        .map((cipher) => cipher.cipher_name)
        .join(", ");
    return (React.createElement("div", null,
        "Version: ",
        protocol.version,
        React.createElement("div", { className: styles["secondary-text"] },
            React.createElement(LongTextLabel, { label: `Cipher suites: ${ciphers}`, title: ciphers }))));
};
const Details = ({ protocol }) => {
    return (React.createElement(Card.Card, { fullWidth: true },
        React.createElement(Card.Title, null, "Protocol details"),
        React.createElement(Card.Content, null,
            React.createElement(KeyValueList, { list: [
                    {
                        Protocol: `${protocol.type} ${protocol.version}`,
                        ...Object.fromEntries(protocol.properties),
                    },
                    ...protocol.ciphers.flatMap((cipher) => [
                        cipher.cipher_name,
                        {
                            Identifiers: (React.createElement(ValueOrPlaceholder, { value: cipher.identifiers
                                    .map((value) => `0x${value.toString(16)}`)
                                    .join(", ") })),
                            Algorithms: cipher.algorithms.length > 0 ? (cipher.algorithms.map((algorithm) => (React.createElement("div", { key: algorithm.id }, algorithm.type)))) : (React.createElement(ValueOrPlaceholder, { value: "" })),
                        },
                    ]),
                ] }))));
};
export default { Details, Summary };
//# sourceMappingURL=Protocol.js.map